import { render, staticRenderFns } from "./xia.vue?vue&type=template&id=21001aee&scoped=true&"
import script from "./xia.vue?vue&type=script&lang=js&"
export * from "./xia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21001aee",
  null
  
)

export default component.exports